/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Impersonating_AsInputs */

const th_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณกำลังดูระบบในนามของ ${i?.email} เซสชันผู้ดูแลระบบของคุณยังคงอยู่`)
};

const en_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are viewing the platform as ${i?.email}. Your own admin session is intact.`)
};

const ja_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} として表示しています。ご自身の管理者セッションは維持されています。`)
};

const zh_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你正以 ${i?.email} 的身份查看平台。你自己的管理员会话仍然保留。`)
};

const es_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás viendo la plataforma como ${i?.email}. Tu propia sesión de administrador sigue intacta.`)
};

const pt_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você está vendo a plataforma como ${i?.email}. Sua própria sessão de administrador continua intacta.`)
};

const id_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda melihat platform sebagai ${i?.email}. Sesi admin Anda sendiri tetap ada.`)
};

const fr_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous voyez la plateforme en tant que ${i?.email}. Votre propre session d’administrateur est intacte.`)
};

const tl_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tinitingnan mo ang plataporma bilang ${i?.email}. Nananatili ang sarili mong sesyon ng admin.`)
};

const vi_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bạn đang xem nền tảng với tư cách ${i?.email}. Phiên quản trị của bạn vẫn còn.`)
};

const ko_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} 계정으로 플랫폼을 보고 있습니다. 회원님의 관리자 세션은 그대로 유지됩니다.`)
};

const de_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du siehst die Plattform als ${i?.email}. Deine eigene Admin-Sitzung bleibt bestehen.`)
};

const ru_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы смотрите платформу как ${i?.email}. Ваша собственная сессия администратора сохраняется.`)
};

const tr_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Platformu ${i?.email} olarak görüyorsunuz. Kendi yönetici oturumunuz duruyor.`)
};

const it_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stai vedendo la piattaforma come ${i?.email}. La tua sessione di amministratore resta attiva.`)
};

const pl_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oglądasz platformę jako ${i?.email}. Twoja sesja administratora pozostaje.`)
};

const uk_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ви бачите платформу як ${i?.email}. Ваша власна сесія адміністратора зберігається.`)
};

const hi_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आप प्लेटफ़ॉर्म को ${i?.email} के रूप में देख रहे हैं। आपका अपना व्यवस्थापक सत्र बना रहता है।`)
};

const ar_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أنت ترى المنصّة بصفة ${i?.email}. جلستك كمشرف باقية.`)
};

const ms_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda melihat platform sebagai ${i?.email}. Sesi pentadbir anda sendiri kekal.`)
};

const bn_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`আপনি ${i?.email} হিসেবে প্ল্যাটফর্ম দেখছেন। আপনার নিজের প্রশাসক সেশন বহাল আছে।`)
};

const zh_tw2_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你正以 ${i?.email} 的身分檢視平台。你自己的管理者工作階段仍然保留。`)
};

const zh_hk2_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你正以 ${i?.email} 的身分檢視平台。你自己的管理者工作階段仍然保留。`)
};

const ur_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آپ پلیٹ فارم کو ${i?.email} کی حیثیت سے دیکھ رہے ہیں۔ آپ کا اپنا منتظم سیشن قائم ہے۔`)
};

const fa_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`شما پلتفرم را به نام ${i?.email} می‌بینید. نشست مدیریتی خودتان پابرجاست.`)
};

const sw_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unaona jukwaa kama ${i?.email}. Kipindi chako cha usimamizi kinaendelea.`)
};

const nl_impersonating_as = /** @type {(inputs: Impersonating_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je bekijkt het platform als ${i?.email}. Je eigen beheerderssessie blijft bestaan.`)
};

/**
* | output |
* | --- |
* | "You are viewing the platform as {email}. Your own admin session is intact." |
*
* @param {Impersonating_AsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const impersonating_as = /** @type {((inputs: Impersonating_AsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonating_AsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_impersonating_as(inputs)
	if (locale === "ja") return ja_impersonating_as(inputs)
	if (locale === "zh") return zh_impersonating_as(inputs)
	if (locale === "es") return es_impersonating_as(inputs)
	if (locale === "pt") return pt_impersonating_as(inputs)
	if (locale === "id") return id_impersonating_as(inputs)
	if (locale === "fr") return fr_impersonating_as(inputs)
	if (locale === "tl") return tl_impersonating_as(inputs)
	if (locale === "vi") return vi_impersonating_as(inputs)
	if (locale === "ko") return ko_impersonating_as(inputs)
	if (locale === "de") return de_impersonating_as(inputs)
	if (locale === "ru") return ru_impersonating_as(inputs)
	if (locale === "tr") return tr_impersonating_as(inputs)
	if (locale === "it") return it_impersonating_as(inputs)
	if (locale === "pl") return pl_impersonating_as(inputs)
	if (locale === "uk") return uk_impersonating_as(inputs)
	if (locale === "hi") return hi_impersonating_as(inputs)
	if (locale === "ar") return ar_impersonating_as(inputs)
	if (locale === "ms") return ms_impersonating_as(inputs)
	if (locale === "bn") return bn_impersonating_as(inputs)
	if (locale === "zh-TW") return zh_tw2_impersonating_as(inputs)
	if (locale === "zh-HK") return zh_hk2_impersonating_as(inputs)
	if (locale === "ur") return ur_impersonating_as(inputs)
	if (locale === "fa") return fa_impersonating_as(inputs)
	if (locale === "sw") return sw_impersonating_as(inputs)
	if (locale === "nl") return nl_impersonating_as(inputs)
	return en_impersonating_as(inputs)
});